import React from 'react';
import { XIcon } from 'lucide-react';
import { pains } from '../data/content';
export function Pains() {
  return <section aria-labelledby="pains-title" className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-162" data-mp="mfajwrx0obff">
      <div className="max-w-2xl" data-id="element-163" data-mp="r83n3bcu7bpe">
        <h2 id="pains-title" className="font-display text-4xl font-bold text-bone sm:text-5xl" data-id="element-164" data-mp="r959ud37tmmy">¿Te pasa esto?</h2>
        <p className="mt-3 text-lg text-mist" data-id="element-165" data-mp="vagpbpsdkrhf">Si organizás Halloween en casa con chicos, esto te suena familiar:</p>
      </div>

      <ul className="mt-12 grid gap-x-12 sm:grid-cols-2" data-id="element-166" data-mp="3gy80yeq0ng5">
        {pains.map(p => <li key={p.title} className="flex gap-4 border-t border-line py-5" data-id="element-167" data-mp="7jb9vbqck17n">
            <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-blood/15 text-blood" data-id="element-168" data-mp="7lea0ol7raq3">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-169" data-mp="1iyq78gmgwv3a" />
            </span>
            <div data-id="element-170" data-mp="1nxb88i9jniss">
              <h3 className="font-bold text-bone" data-id="element-171" data-mp="1nws1lxpcggu2">{p.title}</h3>
              <p className="mt-1 text-mist" data-id="element-172" data-mp="1nze7zu0i0qap">{p.text}</p>
            </div>
          </li>)}
      </ul>

      <p className="mt-14 text-center font-display text-3xl font-semibold text-pumpkin sm:text-4xl" data-id="element-173" data-mp="1bjjbljgsoqi3">
        ¿Cuántos Halloweens más vas a improvisar el mismo día?
      </p>
    </section>;
}